/**
 * Function to loop over all tab instaces on the page and initialize them.
 * @param {*} instances 
 * @returns 
 */
export function initializeTabs(instances) {
    if (!instances) return;

    instances.forEach(instance => {
        const toggleItems = instance.querySelectorAll(".tabs__item");
        const contents = instance.querySelectorAll(".tabs__content .tabs__content__section");

        // Show the first tab and content on page load and mark them afterwards as initialized
        // console.log(instance.getAttribute("data-initialized"));
        if (!instance.getAttribute("data-initialized")) {
            toggleTab(toggleItems[0], contents[0]);
            instance.setAttribute("data-initialized", true);
        }

        // Loop through all toggle items
        toggleItems.forEach((toggle, index) => {
            // Get toggle button
            const button = toggle.querySelector(".tabs__item__toggle");
            // Add click event listener to the toggle button
            button.addEventListener("click", () => {
                hideAllTabs(toggleItems, contents); // Hide all tabs
                toggleTab(toggle, contents[index]); // Toggle the clicked tab
            });
        });
    });

}


/**
 * Helper function to toggle a tab
 * @param {Element} toggle Toggle button element
 * @param {Element} content Tab content element
 */
function toggleTab(toggle, content) {
    // Add 'active' class to the toggle button
    toggle.classList.add("tab-nav__item--active");

    // Show content of tab
    content.style.display = "block";
}


/**
 * Helper function to disable all tabs
 * @param {Element[]} toggles Array of toggle items
 * @param {Element[]} contents Array of tab content elements
 */
function hideAllTabs(toggles, contents) {
    // Loop through buttons and remove 'active' class
    toggles.forEach(toggle => {
        toggle.classList.remove("tab-nav__item--active");
    });

    // Loop through contents and set them hidden
    contents.forEach(content => {
        content.style.display = "none";
    });
}
